import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import ProviderPassPanel from "../components/ProviderPassPanel";

registerExtension(
  "_site.dashboard.myprofile.details",
  ProviderPassPanel,
  "ProviderPassPanel"
);
